import produce from 'immer'
import moment from 'moment'
import { constants } from './actions'
import { commonConstants } from '../common/actions'
import getLookups from '../../views/Config/lookups'
import { generateSelectFormMapper} from 'redux/utils/formMapper'
import clearPersistedLocalStorage from '../../utils/persistedLocalStorage'
import { headTraumaUtils } from '../questionnaire/utils'

const { REQUEST, SUCCESS, FAILURE } = commonConstants
const { UPDATE_QUESTIONNAIRE_VIEW_UPDATE_FORM_FIELD, UPDATE_FORM, RETRIEVE_CALL_REPORT } = constants
const states = require('../../views/Config/usStates.json')
const provinces = require('../../views/Config/canadaProvinces.json')
const australiaStates = require('../../views/Config/australiaStates.json')
const { veteranRanks, callerStruggles, callerTypes, coplineReferralReasons, impairmentReasons, militaryBranches, timeZones, countries, callEntryTypes, headTraumaChecks } = getLookups()
const toHeadTraumaSelectObj = generateSelectFormMapper("headTraumas")
const { cleanHeadTraumas, resolveHeadTraumaCheck } = headTraumaUtils(headTraumaChecks)

function findProvinceState(country, provinceState) {
  const regionMap = { USA: states, CANADA: provinces, AUSTRALIA: australiaStates }
  if (country && regionMap[country]) {
    return regionMap[country].find(r => r.value === provinceState) || null
  }
  const allRegions = [states, provinces, australiaStates]
  for (const regions of allRegions) {
    const match = regions.find(r => r.value === provinceState)
    if (match) return match
  }
  return null
}

const initState = {
  callEntryType: callEntryTypes[0],
  name: '',
  email: '',
  cellPhone: '',
  homePhone: '',
  isFrequentCaller: null,
  isVeteran: null,
  veteranBranch: '',
  yearsOfMilitaryService: '',
  isDisabled: null,
  receivedVaTreatment: null,
  gender: null,
  veteranRank: '',
  yearsOfPoliceService: '',
  country: countries[0],
  provinceState: '',
  city: '',
  departmentSize: '',
  callerType: '',
  age: '',
  coplineReferral: '',
  impairment: '',
  currentStruggle: '',
  callStart: moment(),
  callEnd: moment(),
  callReason: '',
  isSuicidalCall: null,
  callWasReferred: null,
  referralDetails: '',
  returnCall: null,
  returnCallDate: null,
  returnCallTimezone: '',
  returnCallDetails: '',
  safeReturnCallDetails: '',
  returnCallFollowUpNotes: '',
  resolvedReturnCalls: [],
  unResolvedReturnCalls: [],
  originCallReportId: 0,
  callType: 'ORIGIN',
  combatExperience: null,
  treatedForPtsd: null,
  otherMedicalCondition: null,
  headTraumaCheck: headTraumaChecks.REPORTED,
  headTrauma: [],
  // async
  loading: {},
  error: {},
  success: {}
}

export default function reducer (state = initState, action) {
  switch (action.type) {
    case UPDATE_QUESTIONNAIRE_VIEW_UPDATE_FORM_FIELD:
      if (action.field === 'returnCall' && action.value) {
        return produce(state, draft => {
          draft[action.field] = action.value
          draft.loading = {}
          draft.error = {}
          draft.success = {}
          draft.returnCallDate = new Date()
        })
      }
      return produce(state, draft => {
        draft[action.field] = action.value
        draft.loading = {}
        draft.error = {}
        draft.success = {}
        if (action.field === 'headTraumaCheck') {
          draft.headTrauma = cleanHeadTraumas(action.value)
        }
      })
    case UPDATE_FORM + REQUEST:
    case RETRIEVE_CALL_REPORT + REQUEST:
      return produce(state, draft => {
        draft.loading = { source: action.payload.source }
        draft.success = {}
        draft.error = {}
      })
    case UPDATE_FORM + SUCCESS:
      if (action.payload.isUpdate) {
        return produce(state, draft => {
          draft.success = action.payload
          draft.loading = {}
        })
      }
    case UPDATE_FORM + FAILURE:
      if (action.payload.isUpdate) {
        return produce(state, draft => {
          draft.error = action.payload
          draft.loading = {}
        })
      }
    // eslint-disable-next-line
    case RETRIEVE_CALL_REPORT + SUCCESS:
      const page = action.payload.page
      const newResult = {
        ...page,
        callEntryType: callEntryTypes.find(cet => cet.value === page.callEntryType),
        veteranBranch: militaryBranches.find(mb => mb.value === page.veteranBranch),
        veteranRank: veteranRanks.find(vr => vr.value === page.veteranRank),
        headTraumaCheck: resolveHeadTraumaCheck(page.headTrauma),
        headTrauma: page.headTrauma ? page.headTrauma.split(',').map(toHeadTraumaSelectObj) : [],
        country: countries.find(c => c.value === page.country),
        provinceState: findProvinceState(page.country, page.provinceState),
        callerType: callerTypes.find(ct => ct.value === page.callerType),
        coplineReferral: coplineReferralReasons.find(crr => crr.value === (page.coplineReferral === 'Repeat Calller' ? 'Previous Caller' : page.coplineReferral)),
        impairment: impairmentReasons.find(ir => ir.value === page.impairment),
        currentStruggle: callerStruggles.find(cs => cs.value === page.currentStruggle),
        returnCallTimezone: timeZones.find(tz => tz.value === page.returnCallTimezone),
        resolvedReturnCalls: page.resolvedReturnCalls || [],
        unResolvedReturnCalls: page.unresolvedReturnCalls || [],
        yearsOfMilitaryService: page.yearsOfMilitaryService ? Number(page.yearsOfMilitaryService) : null,
        yearsOfPoliceService: page.yearsOfPoliceService ? Number(page.yearsOfPoliceService) : null,
        callReason: page.callReason || '',
        isSuicidalCall: page.isSuicidalCall === true,
        name: page.name || '',
      }
      clearPersistedLocalStorage()
      return {
        ...newResult,
        success: { source: action.payload.source, message: action.payload.message },
        loading: {},
        error: {}
      }
    default:
      return state
  }
}
